export default __webpack_public_path__ + "static/media/photo.9452e973.png";